import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { usePage } from "@inertiajs/vue3";
import { computed, nextTick, onMounted } from "vue";

export function useTour(tourId, steps, options = {}) {
  const page = usePage();

  const completedTours = computed(
    () => page.props.auth?.user?.completed_tours || [],
  );

  const isCompleted = computed(() => completedTours.value.includes(tourId));

  const markCompleted = () => {
    if (completedTours.value.includes(tourId)) return;

    fetch("/tours/complete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
      body: JSON.stringify({ tour_id: tourId }),
    }).then((response) => {
      // Atualiza a prop compartilhada localmente: o fetch acima não passa
      // pelo ciclo do Inertia, então page.props não é recarregado sozinho.
      if (response.ok && page.props.auth?.user) {
        page.props.auth.user.completed_tours = [
          ...completedTours.value,
          tourId,
        ];
      }
    });
  };

  const start = (force = false) => {
    if (!force && isCompleted.value) return;

    nextTick(() => {
      const validSteps = steps.filter((step) => {
        if (!step.element) return true;
        return document.querySelector(step.element);
      });

      if (!validSteps.length) return;

      const driverObj = driver({
        showProgress: true,
        animate: true,
        overlayColor: "rgba(0, 0, 0, 0.6)",
        stagePadding: 8,
        stageRadius: 8,
        allowClose: true,
        doneBtnText: "Concluir",
        nextBtnText: "Próximo",
        prevBtnText: "Anterior",
        closeBtnText: "Pular",
        progressText: "{{current}} de {{total}}",
        ...options,
        steps: validSteps,
        onDestroyStarted: () => {
          markCompleted();
          driverObj.destroy();
        },
      });

      driverObj.drive();
    });
  };

  if (options.autoStart !== false) {
    onMounted(() => {
      setTimeout(() => start(), 500);
    });
  }

  return { start, isCompleted, markCompleted };
}
